import { resolveEndpoint } from "@aws-sdk/util-endpoints";
import { ruleSet } from "./ruleset";
export const defaultEndpointResolver = function (endpointParams) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return resolveEndpoint(ruleSet, {
    endpointParams: endpointParams,
    logger: context.logger
  });
};